module.exports = __webpack_public_path__ + "media/images/arrow-play-94cffbd1d6f83a5d9c5d5c21b127814d.svg";